import type { AdminPage } from '@/components/admin/adminPages'
import * as S from './AdminMenu.styled'

type AdminMenuItemProps = {
  page: AdminPage
  active: boolean
  onSelect: (path: string) => void
}

export const AdminMenuItem = ({
  page,
  active,
  onSelect,
}: AdminMenuItemProps) => (
  <S.Item
    to={page.path}
    $active={active}
    aria-current={active ? 'page' : undefined}
    onClick={() => onSelect(page.path)}
  >
    {page.label}
  </S.Item>
)
